import { CsvTemplate, CsvTemplateSelectedField } from "@finway-group/shared/lib/models"
import { Rule } from "antd/lib/form"
import { i18n } from "~Shared/locales/i18n"

export const createCsvTemplateRules = (templates: Array<CsvTemplate>) => ({
    name: [
        { required: true, message: i18n.t("validation:required") },
        {
            validator: (_rule, value: string) => {
                if (value) {
                    if (templates.map(({ name }) => name).includes(value.trim())) {
                        return Promise.reject(new Error(i18n.t("validation:csv_settings_name_unique")))
                    }
                    if (!value.trim()) {
                        return Promise.reject(new Error(i18n.t("validation:name")))
                    }
                }
                return Promise.resolve()
            },
        },
    ] as Array<Rule>,
    csvHeadersTable: [
        {
            required: true,
            validator: (_rule, value: Array<CsvTemplateSelectedField>) => {
                if (value.length === 0) {
                    return Promise.reject(new Error(i18n.t("validation:csv_settings_headers_empty")))
                }
                return Promise.resolve()
            },
        },
    ] as Array<Rule>,
})
